import ConditionalRender from "../ConditionalRender";
import useCustomTranslation from "core/customTranslation";
import {useEffect, useState} from "react";
import Button from "react-bootstrap/esm/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const translations = {
    es: {
        title: "Ubicación GPS",
        "title.device": "Ubicación GPS (dispositivo)",
        "title.asset": "Ubicación GPS (Contenedor)",
        notData: "No hay coordenadas disponibles para el dispositivo.",
        lat: "Latitud",
        lng: "Longitud",
        action: "Copiar Ubicación",
    },
    en: {
        title: "GPS Location",
        "title.device": "GPS Location (device)",
        "title.asset": "GPS Location (Container)",
        notData: "No coordinates available for the device.",
        lat: "Latitude",
        lng: "Longitude",
        action: "Copy Location",
    },
};

const ItemExpected = {
    lat: 0,
    lng: 0,
    uuid: "",
    uid: "",
};

const CoordinatesShowCopy = ({item = ItemExpected, formData = null, setFormData = null}) => {
    const {t: _T} = useCustomTranslation(translations);

    const getFallback = () => {
        return (
            <div className="card p-3 mb-3">
                <h6 className="card-title">{_T("title")}</h6>
                <div className="row">
                    <div className="col-12 mt-2">
                        <small className="text-muted">{_T("notData")}</small>
                    </div>
                </div>
            </div>
        );
    };

    const getTitle = () => {
        if (item.uuid) {
            return _T("title.device") + ` UUID: ${item.uuid}`;
        } else {
            return _T("title.asset") + ` UID: ${item.uid}`;
        }
    };

    const copyToFormData = () => {
        if (formData && setFormData) {
            setFormData({...formData, lat: item.lat, lng: item.lng});
        }
    };

    return (
        <ConditionalRender condition={item.lat && item.lng} fallback={getFallback()}>
            <div className="card p-3 mb-3">
                <h6 className="card-title">{getTitle()}</h6>
                <div className="row">
                    <div className="col-md-5">
                        <label htmlFor="show-lat" className="form-label small">
                            {_T("lat")}
                        </label>
                        <input type="number" className="form-control text-end" id="show-lat" value={item.lat} readOnly disabled />
                    </div>
                    <div className="col-md-5">
                        <label htmlFor="show-lng" className="form-label small">
                            {_T("lng")}
                        </label>
                        <input type="number" className="form-control text-end" id="show-lng" value={item.lng} readOnly disabled />
                    </div>
                    <div className="col-2 mt-3 text-end">
                        <ConditionalRender
                            condition={formData && setFormData && (item.lat !== formData.lat || item.lng !== formData.lng)}>
                            <Button title={_T("action")} variant="outline-primary" type="button" onClick={copyToFormData}>
                                <FontAwesomeIcon icon="fa-copy" />
                            </Button>
                        </ConditionalRender>
                    </div>
                </div>
            </div>
        </ConditionalRender>
    );
};

export default CoordinatesShowCopy;
